// removed by extract-text-webpack-plugin
module.exports = {"modalWrapper":"_2tSECMiWdHuR2ieB0TDjFq","modalBG":"_2hDUxaLOI9ROCEWkthQ8FU","is-open":"_4DGmTn_EhlOSKrpQ65PQa","closeWrapper":"_31WnQym-RcguQQUbqDuJHi","closeIcon":"YVBt7YHb6VcaQWAjsNG6y","modalImgWrapper":"_19fW2LtbnpCL9G0ULJO6NU","modalImgWr":"_2svrjLxI8tfGV-nzrAVLYX","is-active":"HBczIyMDgN0sI6QCVMjQF","modalImg":"_2kwghM78OxOcF_CAzPXWUL","arrowLeft":"_1tqHgFr5uvixvLYgRnad40","arrowLeftIcon":"L9UJMH43gUHYqjlTpLK7O","arrowRight":"LSbfst0hljOW5Kzr8BXWa","arrowRightIcon":"_2QhCqZ6KL4btOfV73PiIit"};


//////////////////
// WEBPACK FOOTER
// ./src/blocks/MyGallery/index.css
// module id = 276
// module chunks = 0